<template>
<div class="svg-border">
  <div class="svg-line"></div>
  <div class="svg-title">{{ title }}</div>
  <div class="svg-line"></div>
</div>

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>

<style scoped="scoped">
  .title-subtile-holder .svg-title {
    margin-top: 0;
  }
  .title-subtile-holder .svg-border {
    width: 100%;
    height: 23px;
    text-align: center;
    margin: 5px 0 10px;
  }
  .title-subtile-holder {
    margin-bottom: 25px;
  }
  /* ////  */
  .svg-border {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%; /* Expand full width for center alignment */
    margin: 5px 0 10px;
    flex-wrap: wrap;
  }
  .svg-line {
    width: 120px;                  /* Fixed width as requested */
    height: 3px;                   /* Thicker line for boldness */
    background-color: #333;        /* Slightly darker than #ccc for bold effect */
  }

  .svg-title {
    font-size: 30px;        /* Base size on desktop */
    font-weight: bold;
    color: black;
    white-space: nowrap;
    text-align: center;
  }


  /* /////  */

  @media (max-width: 767.98px) {
    .svg-border{
      display:flex;
      justify-content: center;
    }
    .svg-title {
      font-size: 24px; /* Slightly smaller on mobile */
    }
  }

</style>
